export const MenuItems = [
    {
        title: 'After School Tutoring',
        path: '/projects/after-school',
        cName: 'drpdown-link'
    },
    {
        title: 'Scholarships',
        path: '/projects/scholarships',
        cName: 'drpdown-link'
    },
    {
        title: 'Public Health',
        path: '/projects/public-health',
        cName: 'drpdown-link'
    },{
        title: 'Human Development',
        path: '/projects/human-development',
        cName: 'drpdown-link'
    },
    {
        title: 'Nature Based Solutions',
        path: '/projects/nature-based-solutions',
        cName: 'drpdown-link'
    }
]